var Banner = function () {

	this.init = function () {
		toggleWidth()

		$(window).on('resize', function(){
			toggleWidth()
		})
	}

	function toggleWidth() {
		if ($(window).width() < 768) {
			$('[data-component="banner"] [data-component="gradient-text-box"]').css('max-width', 'none');
		}
	}

	return this.init();
}
